import { render } from "./FlowMeterProduct.vue?vue&type=template&id=4b98a3e2&scoped=true"
import script from "./FlowMeterProduct.vue?vue&type=script&lang=js"
export * from "./FlowMeterProduct.vue?vue&type=script&lang=js"

import "./FlowMeterProduct.vue?vue&type=style&index=0&id=4b98a3e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b98a3e2"]])

export default __exports__